/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

// components
import { Skeleton, Tooltip, Typography } from "antd";
// misc
import { hexToRgb } from "@/utils/css/hexToRgb";
import { InfoCircleTwoTone } from "@ant-design/icons";

const baseClassName = "info-card";

export const InfoCard = ({
  title,
  tooltip,
  info,
  color = "",
  colorBg = "",
  className,
  loading = false,
  height = "auto",
}: {
  title: string;
  tooltip?: string;
  info: { label: string; value: string }[];
  color?: string;
  colorBg?: string;
  className?: string;
  loading?: boolean;
  height?: number | string;
}) => {
  let rgbColor = { r: 160, g: 159, b: 238 };
  try {
    rgbColor = hexToRgb(colorBg);
  } catch (err) {
    console.log(err);
  }

  return (
    <div
      className={`${baseClassName} ${className}`}
      style={{
        color: color,
        background: `linear-gradient(360deg, rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.2) 0%, rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.08) 100%)`,
        height,
      }}
    >
      <Typography.Title className={`${baseClassName}__title`} level={5}>
        {title}
        {tooltip ? (
          <Tooltip title={tooltip}>
            <InfoCircleTwoTone className="ml-2" />
          </Tooltip>
        ) : null}
      </Typography.Title>

      {loading ? (
        <Skeleton className="py-1" paragraph={{rows: 0}} />
      ) : (
        info.map((item) => (
          <div className={`${baseClassName}__body`}>
            <Typography.Paragraph
              className={`${baseClassName}__description mb-0`}
            >
              {item.label}
            </Typography.Paragraph>
            <Typography.Paragraph className={`${baseClassName}__value mb-0`}>
              {item.value}
            </Typography.Paragraph>
          </div>
        ))
      )}
    </div>
  );
};
